import { render, staticRenderFns } from "./rJsonEditor.vue?vue&type=template&id=0fb746ca&scoped=true"
import script from "./rJsonEditor.vue?vue&type=script&lang=js"
export * from "./rJsonEditor.vue?vue&type=script&lang=js"
import style0 from "./rJsonEditor.vue?vue&type=style&index=0&id=0fb746ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb746ca",
  null
  
)

export default component.exports